<template>
  <layout-main-inner title="企业详情">
    <div slot="action">
      <button-back />
      <el-button
        v-if="permission.OPERATE"
        type="primary"
        @click="update">
        编辑
      </el-button>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="title">基本信息</template>
      <el-form
        v-loading="loading"
        label-width="120px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="企业名称：">
              {{ info.vendorName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="信用代码：">
              {{ info.unifiedCreditCode }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="地址：">
              {{ info.vendorAddress }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="联系人：">
              {{ info.vendorPerson }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号：">
              {{ info.vendorMobile }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="E-mail：">
              {{ info.vendorEmail }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            v-if="permission.OPERATE"
            :span="8">
            <el-form-item label="企业账号：">
              {{ info.adminAccount }}
            </el-form-item>
          </el-col>
          <el-col
            v-if="permission.OPERATE"
            :span="8">
            <el-form-item label="机构：">
              {{ info.seaportName }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
    <layout-card-wrap hasSlot>
      <template slot="title">品类信息</template>
      <el-table
        border
        :data="info.quarantines">
        <el-table-column
          label="分类名称"
          prop="quarantineName">
        </el-table-column>
        <el-table-column
          label="分类编码"
          width="130"
          prop="quarantineCode">
        </el-table-column>
      </el-table>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'VendorDetail',
  components: {},
  data() {
    return {
      loading: false,
      info: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    if (this.$route.query.vendorId) {
      this.getvendor()
    }
  },
  methods: {
    update() {
      this.$router.push(`/editvendor?vendorId=${this.info.vendorId}`)
    },
    getvendor() {
      this.loading = true
      this.$store.dispatch('account/getvendor', {
        payload: this.$route.query,
        success: (res) => {
          this.loading = false
          this.info = {
            ...res.data
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
